// Update this file with your personal information before deploying.
export const profile = {
  name: 'Seth Robinson',
  role: 'Software Developer',
  tagline: 'A passion for learning and developing.',
  github: 'https://github.com/sethrobinson29',
  linkedin: 'https://www.linkedin.com/in/seth-robinson-9a2940279/',
  resumeUrl: '/resume.pdf',

  about:
    'Software developer with a love of problem solving. ' +
    'I enjoy turning ideas into polished products and tackling difficult tasks. ' +
    'Open to new opportunities to learn and contribute to great products.',

  // Group skills by category. Add, remove, or rename categories freely.
  skills: {
    Languages: ['PHP', 'JavaScript', 'HTML', 'CSS', 'C++', 'Python', 'Typescript', 'MySQL'],
    Frameworks: ['React', 'Node.js', 'Tailwind CSS'],
    Tools: ['Git', 'GitHub', 'PhpStorm', 'CLI', 'Bash', 'Claude Code', 'GitLab', 'Jira', 'Splunk'],
  },

  // Add a new object here for each project.
  projects: [
    {
      name: 'Jeo Party',
      description:
        'A trivia game built for studying using PHP and React.',
      tech: ['PHP', 'React', 'Node.js'],
      githubUrl: 'https://github.com/sethrobinson29/jeo-party',
    },
    {
      name: 'Chromablocks',
      description:
        'A falling-block puzzle game written in TypeScript using Phaser 3.',
      tech: ['TypeScript', 'Phaser 3', 'Vite'],
      liveUrl: 'https://sethrobinson29.com/tjs/',
      githubUrl: 'https://github.com/sethrobinson29/tjs',
    },
    {
      name: 'Sorting Algorithm Visualizer',
      description:
        'A sorting algorithm visualizer built with Python and Pygame, compiled to WebAssembly and run in the browser.',
      tech: ['Python', 'Pygame', 'WebAssembly'],
      liveUrl: 'https://sethrobinson29.com/python-vis-sort-web/',
      githubUrl: 'https://github.com/sethrobinson29/python-vis-sort-web',
    },
    {
      name: 'Wander',
      description:
        'A Magic: The Gathering deck builder and playtesting app. Build and share decklists, write primers, and goldfish decks on a virtual playtesting table.',
      tech: ['C#', 'Blazor', 'ASP.NET Core', 'PostgreSQL', 'SignalR'],
      githubUrl: 'https://github.com/sethrobinson29/wander',
    },
  ],
};
